// extracted by mini-css-extract-plugin
module.exports = {"languageDropdown":"Navbar_languageDropdown__tknCO","languageDropdownOption":"Navbar_languageDropdownOption__1Lu_k","navbarBrandTitle":"Navbar_navbarBrandTitle__AM_1N"};